module.exports = __webpack_public_path__ + "img/toolstation.7a0f609f.jpg";